
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import UserRelated from './userRelated.vue';
import ProductCenter from './productCenter.vue';
import ProductNotice from './productNotice.vue';
import OnLineClass from './onlineClass.vue';
import ProductDoc from './productDoc.vue';
import CommonTitle from './components/commonTitle.vue';
import Recipient from './recipient.vue';
import Carousel from './components/carousel.vue';

@Component({
  components: {
    UserRelated,
    ProductCenter,
    ProductNotice,
    OnLineClass,
    ProductDoc,
    CommonTitle,
    Recipient,
    Carousel
  }
})
export default class Main extends Vue {
  searchKey: string = '';
  @Getter hotWords: any;

  @Action('getHotWords') getHotWords: Function;
  @Action changesearchObj: (params: object) => void;
  mounted() {
    this.getHotWords({ top: 10 });
  }
  onClick() {
      const user = JSON.parse(localStorage.logonUser);
      const url =
      "https://robotapi.fdcyun.com/?channel=corp&redirect=/&biz_id=CORP-XIAOSHOU&version=CORP-XIAOSHOU&userguid=" +
      user.UserGUID +
      "&phone=" +
      user.MobilePhone +
      "&email=" +
      user.Email +
      "&username=" +
      user.UserName +
      "&openid=" +
      user.UserCode +
      "";
      window.open(url);
    // window.open(
    //   'https://mingyuanyun.faqrobot.cn/robot/chat2.html?jid=55&amp;sysNum=1476067342641247&amp;sourceId=297'
    // );
  }
  handleSearch() {
    const { title } = this.$route.meta;
    if (title !== '全局搜索') {
      this.$router.push({ path: '/home/globalSearch' });
    }
    this.changesearchObj({
      time: new Date().getTime(),
      searchKey: this.searchKey
    });
  }
  linkToSearch(key: any) {
    this.$router.push({
      path: '/home/globalSearch'
    });
    this.changesearchObj({
      time: new Date().getTime(),
      searchKey: key
    });
  }
}
